import {OPERATOR_STATUS_OFFLINE, OPERATOR_STATUS_ONLINE, OperatorStatus} from "~/chat/ts/data/OperatorStatus";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {
    OPERATOR_RELOAD_APP_CONFIG,
    OperatorApplicationEventManager,
    SET_OPERATOR_STATUS,
    SetOperatorStatusEventPayload
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OPERATOR_APPLICATION_RELOAD_DATA_EVENT} from "~/operatorApplication/ts/service/comet/Constants";

export default async function setOperatorStatus(statusId: OperatorStatus, customStatusId?: string, auto: boolean = false, rememberLastStatus: boolean = false): Promise<Error | void> {
    if (!OperatorAccountStore.hasNonFreeSites) {
        if (auto) {
            return;
        }

        if (statusId != OPERATOR_STATUS_ONLINE || customStatusId) {
            let site = OperatorAccountStore.data.value?.sites[0];
            if (site) {
                OperatorAccountStore.showFreeDialogForSite(site.id);
                return;
            }
        }
    }

    if (typeof statusId != "number") {
        statusId = OPERATOR_STATUS_ONLINE;
    }
    let prevStatus = OperatorAccountStore.status.value.id;
    if (rememberLastStatus) {
        OperatorApplicationConfigInstance.lastOperatorStatus = statusId;
        OperatorApplicationConfigInstance.lastOperatorCustomStatus = customStatusId;
    }
    OperatorAccountStore.setStatusId({statusId, customStatusId});
    let p: OperatorApplicationApi.SetOperatorStatusOpenApiModel = {
        statusId,
        auto,
        customStatusId
    };
    let error: Error;
    try {
        let result = await (new OperatorApiRequest({
            url: "/operator/setStatus",
            p,
            silent: true,
            silentError: true
        })).send();

        if (result.showMessageOnError() || prevStatus == OPERATOR_STATUS_OFFLINE) {
            OperatorApplicationEventManager.emit(OPERATOR_APPLICATION_RELOAD_DATA_EVENT, "setOperatorStatus from offline");
            //OperatorParamsLoader.reload();
        }
    } catch (e) {
        error = e;
        OperatorApplicationEventManager.emit(OPERATOR_APPLICATION_RELOAD_DATA_EVENT, "after setStatusError");
    }
    OperatorApplicationEventManager.emit(OPERATOR_RELOAD_APP_CONFIG, OperatorApplicationConfigInstance);
    return error;
}

OperatorApplicationEventManager.addEventListener(SET_OPERATOR_STATUS, (payload: SetOperatorStatusEventPayload) => {
    setOperatorStatus(payload.statusId, payload.customStatusId, false, !!payload.rememberLastStatus);
})